//Reset data
export const RESET = "SERVICE_UPDATE_RESET"

export const SET_IS_UPDATED = "SERVICE_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "SERVICE_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "SERVICE_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "SERVICE_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "SERVICE_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "SERVICE_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "SERVICE_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "SERVICE_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "SERVICE_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "SERVICE_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "SERVICE_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "SERVICE_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "SERVICE_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "SERVICE_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "SERVICE_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "SERVICE_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "SERVICE_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "SERVICE_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "SERVICE_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "SERVICE_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "SERVICE_UPDATE_SET_MODAL_TYPE"